import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './SidebarMenu.css';
import { usePageMaskContext } from 'contexts/PageMaskContext';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  Box,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
  withStyles,
} from '@material-ui/core';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    top: '71px !important',
    left: '0px !important',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

export function SidebarMenu({ isOpen }) {
  const { availablePages, handleSidebarEvent, pageMaskState } =
    usePageMaskContext();
  const { t } = useTranslation('PageMask');
  const history = useHistory();
  const availablePagesToDisplay = availablePages.filter(
    (element) => !element.doesNotAppearOnSidebar,
  );

  if (!isOpen) return <></>;
  return (
    <Box>
      <StyledMenu
        anchorEl
        keepMounted
        open={handleSidebarEvent}
        onClose={handleSidebarEvent}
      >
        {availablePagesToDisplay.map((element) => (
          <MenuItem
            key={`sidebar-item-${element.icon}`}
            className={
              element.id === 'logout' ? 'sidebar-item logout' : 'sidebar-item'
            }
            onClick={() => {
              history.push(element.path);
              handleSidebarEvent();
            }}
          >
            <ListItemIcon>
              <FontAwesomeIcon className="sidebarIcons" icon={element.icon} />
            </ListItemIcon>
            <Typography className="sidebar-text" variant="p">
              {t(element.title)}
            </Typography>
          </MenuItem>
        ))}
      </StyledMenu>
    </Box>
  );
}

SidebarMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};
